(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/deposit/express-deposit.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/deposit/express-deposit.js');
'use strict';

const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  DepositInfo
} = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents;
const {
  OnboardingDepositAmountInfo,
  DepositInput,
  DepositButton
} = svs.accountservicesReact.deposit.depositShared;
const {
  Form,
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  showChangeBankQuestionAsync
} = svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs;
const {
  amountChangeAction
} = svs.accountservicesReact.deposit.store.deposit.actions;
const ExpressDeposit = _ref => {
  let {
    accountList,
    bankName,
    isPlayerRegistration,
    onClickChangeBank,
    onClickDeposit
  } = _ref;
  const [selectedBankAccount, setSelectedBankAccount] = React.useState('-1');
  const amount = ReactRedux.useSelector(state => state.deposit.amount);
  const [noBankAccountSelected, setNoBankAccountSelected] = React.useState(false);
  const [showBankName, setShowBankName] = React.useState(true);
  const dispatch = ReactRedux.useDispatch();
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  React.useEffect(() => {
    const {
      hasInstantPayAmount
    } = svs.accountservicesReact.deposit.helpers.sharedHelpers;
    const recentBankAccount = accountList && accountList.filter(a => a.recent === 1);
    if (recentBankAccount.length > 0) {
      setSelectedBankAccount(recentBankAccount[0].bban);
    }
    if (bankName && bankName.length > 2) {
      setShowBankName(true);
    }
    if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  }, [accountList, bankName, instantPay, dispatch]);
  const handleChangeBank = async () => {
    try {
      await showChangeBankQuestionAsync();
      onClickChangeBank();
    } catch (_unused) {
    }
  };
  const handleOnChangeBankAccount = e => {
    setNoBankAccountSelected(false);
    setSelectedBankAccount(e.target.value);
  };
  const handleSubmitDeposit = (e, _formData, isValid) => {
    e && e.preventDefault();
    e && e.stopPropagation();
    if (selectedBankAccount === '-1') {
      setNoBankAccountSelected(true);
      return;
    }
    if (!isValid) {
      return;
    }
    setSelectedBankAccount(selectedBankAccount);
    onClickDeposit({
      accountNumber: selectedBankAccount,
      amount
    });
  };
  return React.createElement("div", {
    className: "margin-top-2"
  }, showBankName && React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    xs: 8
  }, React.createElement("div", null, React.createElement("div", null, "Vald bank"), React.createElement("div", {
    className: "h4"
  }, bankName))), React.createElement(GridCol, {
    xs: 4
  }, React.createElement("div", {
    className: "align-right"
  }, React.createElement(Button, {
    onClick: handleChangeBank,
    transparent: true
  }, " Byt bank"))))), React.createElement(Form, {
    method: "post",
    onSubmit: (e, formData, isValid) => {
      handleSubmitDeposit(e, formData, isValid);
    }
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste ange ett bankonto",
    hasError: noBankAccountSelected,
    idForInput: "bankaccountslist",
    v2: true
  }, React.createElement(Select, {
    id: "bankaccountslist",
    label: "Bankkonto",
    onChange: e => handleOnChangeBankAccount(e),
    v2: true,
    value: selectedBankAccount
  }, React.createElement(Option, {
    disabled: true,
    value: "-1"
  }, "V\xE4lj ett bankkonto"), accountList && accountList.length > 0 && accountList.map(ac => React.createElement(Option, {
    key: ac.bban,
    value: ac.bban
  }, ac.name, ' ', ac.bban)))), React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: amount
  }), React.createElement(DepositButton, null)), React.createElement(DepositInfo, null), !showBankName && React.createElement("div", null, "Om du har fler banker s\xE5 kan du byta bank", ' ', React.createElement("a", {
    onClick: handleChangeBank
  }, "h\xE4r")));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.deposit.ExpressDeposit = ExpressDeposit;

 })(window);